import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './FileManager.css';

const CustomFile = ({ file }) => {
  return (
    <div className="file-item">
      <div className={`file-item-icon far fa-file-alt text-secondary`}></div>
      <div className="file-item-name">
        {file.name}
      </div>
    </div>
  );
};

export default CustomFile;
